import { render, staticRenderFns } from "./appelTeacher.vue?vue&type=template&id=4e79f94a&"
import script from "./appelTeacher.vue?vue&type=script&lang=js&"
export * from "./appelTeacher.vue?vue&type=script&lang=js&"
import style0 from "./appelTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports